import React, { Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  Divider,
  Button,
  Grid,
} from '@material-ui/core';
import { ArrowForwardIos, Search } from '@material-ui/icons';

import useStyles from './styles';

import DiasFechaHora from './DiasFechaHora';
import SelectorServicio from './SelectorServicio';
import Loading from './Skeleton';

//actions
import {
  setterBusqueda,
  getServicios,
  setSelectedServicioVuelta,
} from '../../redux/actions/serviciosActions';

export default function TabServiciosIda({ resultadoServicios }) {
  const classes = useStyles();

  const token = useSelector((state) => state.auth.token);
  const objCantidad = useSelector((state) => state.servicios.cantidad);

  const busqueda = useSelector((state) => state.servicios.busqueda);
  const servicios = useSelector((state) => state.servicios.servicios.vuelta);
  const servicioSelected = useSelector(
    (state) => state.servicios.serviciosSeleccionados.vuelta
  );
  const dispatch = useDispatch();

  const [dataSearchServicio, setDataSearchServicio] = useState(busqueda);
  const [buscando, setBuscando] = useState(false);

  const handleInputChange = (e) => {
    const data = {
      ...dataSearchServicio,
      [e.target.name]: e.target.value,
    };
    setDataSearchServicio(data);
    dispatch(setterBusqueda(data));
  };

  const handleBuscarServicios = () => {
    const query = {
      busqueda: {
        ...busqueda,
        estacionOrigen: busqueda.estacionDestino,
        estacionDestino: busqueda.estacionOrigen,
      },
      cantidad: objCantidad,
    };
    dispatch(getServicios({ ida: false, token, query }));
    setBuscando(true);
  };

  return (
    <Fragment>
      <Grid container spacing={1} className={classes.container}>
        <Grid item xs={12} md={9}>
          <Typography variant='h6' className={classes.widthTitle}>
            Selecciona el mejor servicio para vos
          </Typography>
        </Grid>
        <Grid item xs={12} md={3}></Grid>
        <Grid item xs={12}>
          <List component='nav' aria-label='main mailbox folders'>
            <ListItem>
              <ListItemIcon>
                <ArrowForwardIos />
              </ListItemIcon>
              <ListItemText primary={'VIAJE DE VUELTA'} />
              <ListItemSecondaryAction>
                <Divider />
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </Grid>
        <Grid item xs={12}>
          <DiasFechaHora
            fieldSelected={dataSearchServicio}
            setDataSearchServicio={handleInputChange}
            vuelta={true}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            variant='contained'
            // color='primary'
            color='secondary'
            startIcon={<Search />}
            onClick={handleBuscarServicios}
            className={classes.button}
          >
            Buscar Servicios Vuelta
          </Button>
          <br />
        </Grid>
        {servicios && (
          <SelectorServicio
            servicios={servicios}
            servicioSelected={servicioSelected}
            selectedServicioRedux={setSelectedServicioVuelta}
          />
        )}
        {buscando && servicios === null ? <Loading /> : ''}
      </Grid>
    </Fragment>
  );
}
